module.exports = __webpack_public_path__ + "static/media/johannMuller.50a19a97.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/johannMuller.jpg
// module id = 1678
// module chunks = 1